import { FilterData } from 'path-shared/models/filter-data';
import { SortDirection } from '@angular/material';

export class TipusVehiclesFilter extends FilterData {
  id: number;
  descripcio: string;
  matriculaObligatoria: boolean;

  constructor(sortField: string, sortDir: SortDirection) {
    super(sortField, sortDir);
    this.id = null;
    this.descripcio = '';
    this.matriculaObligatoria = null;

    this.labels['id'] = this.i18n('Id');
    this.labels['descripcio'] = this.i18n('Descripció');
    this.labels['matriculaObligatoria'] = this.i18n('Matricula obligatòria');
  }
}
